import { useMemo } from "react";
import FirmFlowTable from "../../components/mytasks/FirmFlowTable";
import NewBadge from "../../components/NewBadge";
import { getBgColorFromDate } from "../../helpers/getBgColorFromDate";
import { formatDate } from "../../helpers/formatDate";
import { sortDueDateRows } from "../../helpers/sortDueDateRows";

const STATUSES = ["To Do", "In Progress", "Complete"];

const getAssignedByLabel = (value) => {
    if (!value) return "-";

    if (typeof value === "string") {
        return value || "-";
    }

    if (typeof value === "object") {
        if (typeof value.fullName === "string" && value.fullName.trim() !== "") {
            return value.fullName;
        }

        const firstName = value.firstName ?? "";
        const lastName = value.lastName ?? "";
        const fullName = `${firstName} ${lastName}`.trim();

        return fullName || "-";
    }

    return "-";
};

const MyAssignedJobsTable = ({
    employeeName,
    data,
    canNavigateToService = true,
    canReadSteps = false,
}) => {
    const columns = useMemo(
        () => [
            {
                Header: "Client",
                accessor: "client",
                Cell: (props) => (
                    <a
                        rel="noreferrer"
                        href={`/clients/service/${props.row.original.subscriptionId}/client/${props.row.original.clientId}`}
                        className="rounded-full text-gray hover:text-blue-500"
                    >
                        {props.row.original.isNew === true ? (
                            <span>
                                <NewBadge label="New" /> {props.value}
                            </span>
                        ) : (
                            props.value
                        )}
                    </a>
                ),
            },
            {
                Header: "Notes",
                accessor: "notes",
                Cell: (props) => (
                    <a
                        rel="noreferrer"
                        href={`/clients/service/${props.row.original.subscriptionId}/client/${props.row.original.clientId}`}
                        className="rounded-full text-gray hover:text-blue-500"
                    >
                        {props.value || "-"}
                    </a>
                ),
            },
            {
                Header: "Service",
                accessor: "service",
                Cell: (props) => (
                    <a
                        rel="noreferrer"
                        href={`/clients/service/${props.row.original.subscriptionId}/client/${props.row.original.clientId}`}
                        className="rounded-full text-gray hover:text-blue-500"
                    >
                        {props.value}
                    </a>
                ),
            },
            {
                Header: "Name",
                accessor: "name",
                Cell: (props) => (
                    <a
                        rel="noreferrer"
                        href={`/clients/service/${props.row.original.subscriptionId}/client/${props.row.original.clientId}`}
                        className="rounded-full text-gray hover:text-blue-500"
                    >
                        {props.value}
                    </a>
                ),
            },
            {
                Header: "Year",
                accessor: "serviceYear",
                Cell: (props) => (
                    <a
                        rel="noreferrer"
                        href={`/clients/service/${props.row.original.subscriptionId}/client/${props.row.original.clientId}`}
                        className="rounded-full text-gray hover:text-blue-500"
                    >
                        {props.value}
                    </a>
                ),
            },
            {
                Header: "Assigned by",
                accessor: "assignedBy",
                Cell: (props) => (
                    <a
                        rel="noreferrer"
                        href={`/clients/service/${props.row.original.subscriptionId}/client/${props.row.original.clientId}`}
                        className="rounded-full text-gray hover:text-blue-500"
                    >
                        {getAssignedByLabel(props.value)}
                    </a>
                ),
            },
            {
                Header: "Assigned",
                accessor: "assignedDate",
                /* accessor: (row) =>
                    new Date(row.assignedDate).toDateString().substring(4), */
                Cell: (props) => (
                    <a
                        rel="noreferrer"
                        href={`/clients/service/${props.row.original.subscriptionId}/client/${props.row.original.clientId}`}
                        className="rounded-full text-gray hover:text-blue-500"
                    >
                        {formatDate(props.value, {
                            dateStyle: "short",
                        })}
                    </a>
                ),
            },
            {
                Header: "Due",
                accessor: "dueDate",
                /* accessor: (row) => new Date(row.dueDate).toDateString().substring(4), */
                Cell: (props) => (
                    <a
                        rel="noreferrer"
                        href={`/clients/service/${props.row.original.subscriptionId}/client/${props.row.original.clientId}`}
                        className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-md font-medium text-white mb-2 ${getBgColorFromDate(
                            props.value,
                        )}`}
                    >
                        {formatDate(props.value, {
                            dateStyle: "short",
                        })}
                    </a>
                ),
            },
            {
                Header: "Status",
                accessor: "jobStatus",
                Cell: (props) => (
                    <a
                        rel="noreferrer"
                        href={`/clients/service/${props.row.original.subscriptionId}/client/${props.row.original.clientId}`}
                        className="rounded-full text-gray hover:text-blue-500"
                    >
                        <span
                            className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-md font-medium text-white ${
                                STATUSES[props.value] === "To Do"
                                    ? "bg-red-500"
                                    : STATUSES[props.value] == "In Progress"
                                    ? "bg-yellow-500"
                                    : "bg-teal-500"
                            }`}
                        >
                            {STATUSES[props.value]}
                        </span>
                    </a>
                ),
            },
        ],
        [employeeName]
    );
    const sortedData = useMemo(
        () =>
            sortDueDateRows(data, {
                dueDateKeys: ["dueDate"],
                yearKeys: ["serviceYear", "year"],
                serviceNameKeys: ["service"],
            }),
        [data],
    );

    if (!canReadSteps) return null;

    return (
        <div
            onClickCapture={(event) => {
                if (!canNavigateToService) {
                    event.preventDefault();
                    event.stopPropagation();
                }
            }}
            aria-disabled={!canNavigateToService}
        >
            <div>
                {data != null ? (
                    <FirmFlowTable
                        columns={columns}
                        data={sortedData}
                        employee={employeeName}
                    />
                ) : (
                    "No data found"
                )}
            </div>
        </div>
    );
};

export default MyAssignedJobsTable;
